import React, { useContext } from 'react'
import { createPortal } from 'react-dom'

import { selectShowDocumentSummary } from '../../../store/processDocument/documentSummary'
import { useAppSelector } from '../../../store/hooks'

import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

import { DELTA_TRIAL_FEATURES } from '../../Plan/DeltaTrial/DeltaTrialFeatures'
import { HeaderContext } from '../../LayoutWithLeftSidebar/HeaderContext'
import { Upsell } from '../../Plan/DeltaTrial/Upsell/Upsell'

import { DocumentSummaryHeader } from '../DocumentSummary/DocumentSummaryHeader'
import { DocumentSummary } from '../DocumentSummary/DocumentSummary'
import { AttachmentSummaryProcessing } from './AttachmentSummaryProcessing'
import { AttachmentSummaryInitialization } from '../Initialization/AttachmentSummaryInitialization'
import { useSearchParams } from 'react-router-dom'

export type AttachmentSummaryTrackingContext = 'web' | 'plugin'

export const AttachmentSummaryPage = () => {
  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()
  const { portalRef } = useContext(HeaderContext)

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  return (
    <>
      {portalRef && portalRef.current ? createPortal(<DocumentSummaryHeader />, portalRef.current) : null}
      {!documentSummaryEnabled ? (
        <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
      ) : (
        <div className='full-size-content'>
          <AttachmentSummaryInitialization />
          <AttachmentSummaryContent />
        </div>
      )}
    </>
  )
}

const AttachmentSummaryContent = () => {
  const showDocumentSummary = useAppSelector(selectShowDocumentSummary)

  const [searchParams] = useSearchParams()

  const context = searchParams.get('trackingContext')
  const trackingContext: AttachmentSummaryTrackingContext =
    context && ['web', 'plugin'].includes(context) ? (context as AttachmentSummaryTrackingContext) : 'web'

  return <div className='h-100 w-100'>{showDocumentSummary ? <DocumentSummary /> : <AttachmentSummaryProcessing trackingEventContext={trackingContext} />}</div>
}
